import axios from '../axios-init';

export const getPaymentRequest = params => {
    return axios.post(`/payment/getPayments`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const addPaymentRequest = params => {
    return axios.post(`/payment/saveOrUpdateById`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const getBankList = params => {
    return axios.post(`/bank/queryBankInfoListNoPage`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const editPaymentStatus = params => {
    return axios.post(`/payment/updatePaymentStatus`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const getPendingTransaction = params => {
    return axios.post(`/payment/getPendingTransaction`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const getTransactionHistory = params => {
    return axios.post(`/payment/getTransactionHistory`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const queryPaymentById = params => {
    return axios.post(`/payment/queryPaymentInfo`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const pay = params => {
    return axios.post(`/payment/pay`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const getBalance = params => {
    return axios.post(`/payment/getBalance`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const addAdjust = params => {
    return axios.post(`/payment/addAdjustBalance`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const getTransaction = params => {
    let list = [
        {
            title: "Withdraw to chase visa 123456",
            user: "护士1",
            amount: 1555,
            balance: "0",
            note: "支付$1555"
        }, {
            user: "护士1",
            product: "product3",
            price: 80,
            quantity: 1,
            amount: 80,
            warehouse: "FL0002",
            date: "2019-08-01",
            balance: "1555"
        }, {
            user: "护士1",
            product: "product2",
            price: 95,
            quantity: 5,
            amount: "475",
            warehouse: "FL0001",
            date: "2019-08-01",
            balance: "1475"
        }, {
            user: "护士1",
            product: "product1",
            price: 100,
            quantity: 10,
            amount: 1000,
            warehouse: "FL0001",
            date: "2019-07-31",
            balance: "1000"
        }];
    return Promise.resolve(list);
};

export const queryBankById = params => {
    return axios.post(`/bank/queryBankInfoById`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const addBanks = params => {
    return axios.post(`/bank/saveOrUpdateBankInfo`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const getNurseBanks = params => {
    return axios.post(`/bank/queryBankInfoList`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};

export const deleteNurseBanks = params => {
    return axios.post(`/bank/deleteBankInfoById`,params).then((res) => {
        return res.data;
    }).catch(error => error)
};



// WEBPACK FOOTER //
// ./src/api/paymentService.js